import { pipe } from 'ramda';
import { StateStatus } from '@alycecom/utils';

import { IRootState } from '../root.types';

import { countriesAdapter } from './countries.reducer';

const getCountriesState = (state: IRootState) => state.countries;

const selectors = countriesAdapter.getSelectors(getCountriesState);

export const getIsFulfilled = pipe(getCountriesState, state => state.status === StateStatus.Fulfilled);

export const getCountries = selectors.getAll;
export const getCountriesMap = selectors.getEntities;
export const getCountryById = selectors.getById;
